import { View } from "react-native";
import { Text, Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  resetFilters: () => void;
};

export default function NoCombinations({ resetFilters }: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-1 items-center")}>
      <Text variant="bodyLarge" style={tailwind("text-center")}>
        No existen combinaciones con las opciones seleccionadas.
      </Text>

      <Button
        mode="contained"
        icon="filter-remove-outline"
        onPress={resetFilters}
        style={tailwind("mt-4")}
      >
        Desactivar filtros
      </Button>
    </View>
  );
}
